import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const subscribeEventTemplate = htmlE`
  <div class="text-xs whitespace-nowrap text-primaryMain has-text-weight-semibold mb-4">
    <span>${"path"}</span>
  </div>
  <form id="subscribeToEventsForms"></form>
`;

export const subscribeEventCheckBoxTemplate = htmlE`
  <div class="is-flex is-align-items-center mt-2">
    <input
      class="subscribe-event-checkbox"
      id="${"id"}"
      type="checkbox"
      name="${"name"}" />
    <label
      for="${"id"}"
      class="text-sm text-primaryMain ml-2"
      data-i18n-key="${"i18n_key"}">
      ${"label"}
    </label>
  </div>
`;
